import Button from "@mp/button";
import { t } from "@mp/locale";
import Modal from "react-modal";
import { useState } from "react";
import Switch from "@mp/switch";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { CookieDetailV3 } from "../types";
import { initialState } from "../constants";
import logo from '../logo.png';

export interface PreferenceModalProps {
  isModalOpen: boolean;
  isUS?: boolean;
  onCloseModal: Function;
  saveAcceptAllCookies: Function;
  savePreferences: (preferences: CookieDetailV3) => void;
}

Modal.setAppElement("body");

export default function PreferenceModal(props: PreferenceModalProps) {
  const { isModalOpen, onCloseModal, saveAcceptAllCookies, savePreferences } =
    props;

  const [preferences, setPreferences] = useState<CookieDetailV3>(initialState);

  function setCustomPreferences(name, checked) {
    setPreferences({
      ...preferences,
      custom: {
        ...preferences.custom,
        [name]: checked,
      },
    });
  }

  function confirmMyChoices() {
    savePreferences(preferences);
  }

  return (
    <Modal
      className="mp-cookie-policy-modal"
      overlayClassName="mp-cookie-policy-modal-overlay"
      isOpen={isModalOpen}
      contentLabel={t("COOKIE_POLICY.cookiePreferenceCenter")}
    >
      <div className="mp-cookie-policy-modal-header">
        <Button
          htmlId="mp-confirm-close-button-cookie-modal"
          aria-label={t("COMMON.ACTIONS.closeDialog")}
          className="mp-confirm-close-button"
          onClick={() => onCloseModal(false)}
          buttonType="link"
          type="button"
        >
          <svg
            className="mp-confirm-close-button-svg"
            width="24"
            height="24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"
              fill="currentColor"
            />
          </svg>
        </Button>
      </div>
      <div className="mp-cookie-policy-modal-content">
        <h1 className="mp-cookie-policy-modal-headline">
          {t("COOKIE_POLICY.cookiePreferenceCenter")}
        </h1>
        <p className="mp-cookie-policy-modal-subhead">
          {t("COOKIE_POLICY.cookiePreferenceDetails")}
          <span className="mp-cookie-policy-modal-subhead-link">
            <a
              className="mp-cookie-policy-modal-subhead-link"
              href="https://matterport.com/cookie-policy"
              target="blank"
            >
              {t("COOKIE_POLICY.moreInfo")}
            </a>
          </span>
        </p>

        <Button
          htmlId="mp-cookie-policy-accept-button"
          className="mp-cookie-policy-accept-button"
          aria-label={t("COOKIE_POLICY.AcceptAllCookies")}
          buttonType="primary"
          type="button"
          dark
          onClick={() => saveAcceptAllCookies()}
        >
          {t("COOKIE_POLICY.AcceptAllCookies")}
        </Button>
        <h1 className="mp-cookie-policy-modal-headline">
          {t("COOKIE_POLICY.manageConsentPreferences")}
        </h1>

        <form className="form-container">
          <div className="accordion-item">
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className="mp-cookie-policy-modal-subhead accordion-title">
                  {t("COOKIE_POLICY.performanceCookies")}
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <p className="mp-cookie-policy-modal-subhead">
                  {t("COOKIE_POLICY.performanceCookiesDetails")}
                </p>
                <div className="mp-cookie-policy-modal-subhead-link">
                  <a href="https://matterport.com/cookie-policy" target="blank">
                    {t("COOKIE_POLICY.cookieDetails")}
                  </a>
                </div>
              </AccordionDetails>
            </Accordion>
            <Switch
              disabled={false}
              checked={preferences.custom["performance"]}
              onChange={(e) =>
                setCustomPreferences(e.target.name, e.target.checked)
              }
              id="switch-performance"
              name="performance"
            />
          </div>
          <div className="accordion-item">
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className="mp-cookie-policy-modal-subhead  accordion-title">
                  {t("COOKIE_POLICY.functionalityCookies")}
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <p className="mp-cookie-policy-modal-subhead">
                  {t("COOKIE_POLICY.functionalityCookiesDetails")}
                </p>
                <div className="mp-cookie-policy-modal-subhead-link">
                  <a href="https://matterport.com/cookie-policy" target="blank">
                    {t("COOKIE_POLICY.cookieDetails")}
                  </a>
                </div>
              </AccordionDetails>
            </Accordion>
            <Switch
              disabled={false}
              checked={preferences.custom["functionality"]}
              onChange={(e) =>
                setCustomPreferences(e.target.name, e.target.checked)
              }
              id="switch-functionality"
              name="functionality"
            />
          </div>
          <div className="accordion-item">
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className="mp-cookie-policy-modal-subhead  accordion-title">
                  {t("COOKIE_POLICY.targetingCookies")}
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <p className="mp-cookie-policy-modal-subhead">
                  {t("COOKIE_POLICY.targetingCookiesDetails")}
                </p>
                <div className="mp-cookie-policy-modal-subhead-link">
                  <a href="https://matterport.com/cookie-policy" target="blank">
                    {t("COOKIE_POLICY.cookieDetails")}
                  </a>
                </div>
              </AccordionDetails>
            </Accordion>
            <Switch
              disabled={false}
              checked={preferences.custom["targeting"]}
              onChange={(e) =>
                setCustomPreferences(e.target.name, e.target.checked)
              }
              id="switch-targeting"
              name="targeting"
            />
          </div>
          <div className="accordion-item">
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className="mp-cookie-policy-modal-subhead  accordion-title">
                  {t("COOKIE_POLICY.strictlyNecessary")}
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <p className="mp-cookie-policy-modal-subhead">
                  {t("COOKIE_POLICY.strictlyNecessaryDetails")}
                </p>
                <div className="mp-cookie-policy-modal-subhead-link">
                  <a href="https://matterport.com/cookie-policy" target="blank">
                    {t("COOKIE_POLICY.cookieDetails")}
                  </a>
                </div>
              </AccordionDetails>
            </Accordion>
            <Switch
              disabled={true}
              checked={true}
              onChange={() => null}
              id="switch-strictly-necessary"
              name="strictly-necessary"
            />
          </div>
        </form>
      </div>
      <footer className="mp-cookie-policy-modal-footer">
        <Button
          htmlId="mp-cookie-policy-confirm-button"
          className="mp-cookie-policy-confirm-button"
          aria-label={t("COOKIE_POLICY.confirmMyChoices")}
          buttonType="primary"
          type="button"
          dark
          onClick={() => confirmMyChoices()}
        >
          {t("COOKIE_POLICY.confirmMyChoices")}
        </Button>
      </footer>
    </Modal>
  );
}
